// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"561":"caa38f63","787":"38f16daf","989":"d3c289ed"}[chunkId] + ".chunk.js";
};